// action types
import { createRequestTypes } from "../../utils";

// Fetch Users with Pro status
export const FETCH_PRO_USERS = createRequestTypes("FETCH_PRO_USERS");

export const fetchProUsersRequest = (params = {}) =>
    ({ type: FETCH_PRO_USERS.REQUEST, payload: params });

export const fetchProUsersSuccess = (data) =>
    ({ type: FETCH_PRO_USERS.SUCCESS, payload: { data } });

export const fetchProUsersFailure = (error) =>
    ({ type: FETCH_PRO_USERS.FAILURE, payload: error });

// Fetch Pro Stats
export const FETCH_PRO_STATS = createRequestTypes("FETCH_PRO_STATS");

export const fetchProStatsRequest = () =>
    ({ type: FETCH_PRO_STATS.REQUEST });

export const fetchProStatsSuccess = (data) =>
    ({ type: FETCH_PRO_STATS.SUCCESS, payload: { data } });

export const fetchProStatsFailure = (error) =>
    ({ type: FETCH_PRO_STATS.FAILURE, payload: error });

// Grant Complimentary Pro
export const GRANT_COMPLIMENTARY_PRO = createRequestTypes("GRANT_COMPLIMENTARY_PRO");

export const grantComplimentaryProRequest = (userId, reason, expiresDays) =>
    ({ type: GRANT_COMPLIMENTARY_PRO.REQUEST, payload: { userId, reason, expiresDays } });

export const grantComplimentaryProSuccess = (data) =>
    ({ type: GRANT_COMPLIMENTARY_PRO.SUCCESS, payload: { data } });

export const grantComplimentaryProFailure = (error) =>
    ({ type: GRANT_COMPLIMENTARY_PRO.FAILURE, payload: { error } });

// Revoke Complimentary Pro
export const REVOKE_COMPLIMENTARY_PRO = createRequestTypes("REVOKE_COMPLIMENTARY_PRO");

export const revokeComplimentaryProRequest = (userId) =>
    ({ type: REVOKE_COMPLIMENTARY_PRO.REQUEST, payload: { userId } });

export const revokeComplimentaryProSuccess = (data) =>
    ({ type: REVOKE_COMPLIMENTARY_PRO.SUCCESS, payload: { data } });

export const revokeComplimentaryProFailure = (error) =>
    ({ type: REVOKE_COMPLIMENTARY_PRO.FAILURE, payload: { error } });

// Bulk Grant Complimentary Pro
export const BULK_GRANT_COMPLIMENTARY_PRO = createRequestTypes("BULK_GRANT_COMPLIMENTARY_PRO");

export const bulkGrantComplimentaryProRequest = (userIds, reason, expiresDays) =>
    ({ type: BULK_GRANT_COMPLIMENTARY_PRO.REQUEST, payload: { userIds, reason, expiresDays } });

export const bulkGrantComplimentaryProSuccess = (data) =>
    ({ type: BULK_GRANT_COMPLIMENTARY_PRO.SUCCESS, payload: { data } });

export const bulkGrantComplimentaryProFailure = (error) =>
    ({ type: BULK_GRANT_COMPLIMENTARY_PRO.FAILURE, payload: { error } });
